import { render, staticRenderFns } from "./detils.vue?vue&type=template&id=00333e8b&scoped=true&"
import script from "./detils.vue?vue&type=script&lang=js&"
export * from "./detils.vue?vue&type=script&lang=js&"
import style0 from "./detils.vue?vue&type=style&index=0&id=00333e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00333e8b",
  null
  
)

export default component.exports